import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { AuthVM } from '../../Structure/ViewModels/Auth/AuthVM'
import { Globals } from '../../Structure/Globals/GlobalObs'

const Login = () => {
    const [vm, setVm] = useState<{viewModel:AuthVM}>({viewModel:Globals.auth})
    const control = vm.viewModel
    useEffect(()=>control.subscribeUpdate(setVm),[])

    
    useEffect(()=>{
        document.getElementById('loginForm')?.addEventListener('submit', function(event) {
            event.preventDefault(); // منع إعادة تحميل الصفحة
            // قم بتنفيذ الكود الذي تريده هنا
            
          });
        

    },[])
  return (
    <form id='loginForm' className='h-100'>
        <Container className='h-100'>
            <Row className='h-100 justify-content-center'>
                <Col md={6} className='d-flex flex-column justify-content-center'>
                    <Row className='d-flex justify-content-center justify-content-md-between py-2'>
                        <Col className='d-flex justify-content-center' sm={6}>
                            <label htmlFor="" className='my-auto py-3 py-sm-0 fw-bold txt-color-I'>الرقم الوظيفي</label>
                        </Col>
                        <Col  className='d-flex justify-content-center' sm={6}>
                            <input type="text" className='input-field my-auto' value={control.LoginData.employee_key} onChange={a=>control.Employee_Key = a.target.value} />
                        </Col>
                    </Row>
                    <Row className='d-flex justify-content-center justify-content-md-between py-3'>
                        <Col className='d-flex justify-content-center'  sm={6}>
                            <label htmlFor="" className='my-auto py-3 py-sm-0 fw-bold txt-color-I'>كلمة السر</label>
                        </Col>
                        <Col className='d-flex justify-content-center'  sm={6}>
                            <input type="password" className='input-field my-auto' value={control.LoginData.password}  onChange={a=>control.Password = a.target.value} />
                        </Col>
                    </Row>
                    <Row className='d-flex justify-content-between'>
                        <Col className='d-flex justify-content-center'  sm={6}>
                            <input id='remember' type='checkbox' checked={control.LoginData.remember} onChange={a=>control.Remmeber = a.target.checked} />
                            <label htmlFor="remember" className='my-auto p-3 py-sm-0 txt-color-I'>تذكرني</label>
                        </Col>
                        <Col className='d-flex justify-content-center py-2'  sm={6}>
                            <button className='my-auto button-I btn-cl-I px-4 py-1' onClick={()=>control.login()}>دخول</button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    </form>
  )
}

export default Login
